import BackendUrl from '../Constants/BackendUrl';
import Environment from '../Enum/Environment';
import {IBaseSearchParam} from '../Types/ISearchParam';
import {MAX_RADIUS} from '../Constants/SearchRadius';
import {setRequestConfig} from './RequestConfig';
import {IDepotInfo} from '../Types/IDepot';
import {removeDepotInfoDuplicate} from '../Utils/ResultsUtils';

interface IConfig {
    maxRadius: number;
    minRadius: number;
}

export const fetchDepots = (env: Environment, searchParam: IBaseSearchParam, config?: IConfig): Promise<IDepotInfo[]> => {
    let maxRadius: number = MAX_RADIUS;
    let minRadius: number = 0;

    if (typeof config !== 'undefined') {
        maxRadius = config.maxRadius;
        minRadius = config.minRadius;
    }

    return new Promise<IDepotInfo[]>((resolve, reject) => {
        fetch(
            `${BackendUrl[env]}/api/depots?latitude=${searchParam.latitude}&longitude=${searchParam.longitude}&min_radius=${minRadius}&radius=${maxRadius}&date=${searchParam.date}&limit=100`,
            setRequestConfig('GET'))
            .then((response: Response) => response.json())
            .then(data => {
               resolve(removeDepotInfoDuplicate(data));
            })
            .catch(() => reject());

    })
}
